const SCSK_IPS = {
  NY: ["144.121.72.102", "23.246.125.30", "24.30.232.162", "71.104.81.99"],
  TX: ["97.77.33.82", "71.104.81.99"],
};

let globalIP = "*";

export const getPublicIP = async () => {
  const getIp = async () => {
    // const res = await fetch("https://geolocation-db.com/json/");
    const res = await fetch(process.env.REACT_APP_DB_URL);
    const data = await res.json();
    console.log("Public IP: ", data);
    // return data.IPv4;
    return data["client host"];
  };

  globalIP = await getIp();
  // console.log("ip in hook: ", ip);
  return globalIP;
};

export const checkIP = (office) => {
  console.log("checkIP", globalIP);
  return SCSK_IPS[office].includes(globalIP);
};
